import "./moreInfo.css";

function MoreInfo() {
  return (
    <div className="infoCards">
      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1527432734427-46138a6ef2df?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGNvdXBsZXMlMjBpbiUyMGxvdmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
              alt=""
            />
          </div>
          <div className="flip-card-back">
            <div className="cardText">
              <p>
                Lots of people want to ride with you in the limo, but what you want is someone who will take the bus with you when the limo
                breaks down.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1461009209120-103a8f970745?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Njl8fGNvdXBsZXMlMjBpbiUyMGxvdmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
              alt=""
            />
          </div>
          <div className="flip-card-back">
            <div className="cardText">
              <p>
                Love is always patient and kind. It is never jealous. Love is never boastful or conceited. It is never rude or selfish. It
                does not take offense and is not resentful. Love takes no pleasure in other people’s sins, but delights in the truth. It is
                always ready to excuse, to trust, to hope, and to endure whatever comes.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1507224839097-4d75f57c5fdf?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NzB8fGNvdXBsZXMlMjBpbiUyMGxvdmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
              alt=""
            />
          </div>
          <div className="flip-card-back">
            <div className="cardText">
              <p>
                To love at all is to be vulnerable. Love anything and your heart will be wrung and possibly broken. If you want to make sure
                of keeping it intact you must give it to no one, not even an animal. Wrap it carefully round with hobbies and little
                luxuries; avoid all entanglements. Lock it up safe in the casket or coffin of your selfishness. But in that casket, safe,
                dark, motionless, airless, it will change. It will not be broken; it will become unbreakable, impenetrable, irredeemable. To
                love is to be vulnerable.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="flip-card-front">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1496156555893-ce6408188e2c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OTl8fGNvdXBsZXMlMjBpbiUyMGxvdmV8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60"
              alt=""
            />
          </div>
          <div className="flip-card-back">
            <div className="cardText">
              <p>
                I believe that everything happens for a reason. People change so that you can learn to let go, things go wrong so that you
                appreciate them when they’re right, you believe lies so you eventually learn to trust no one but yourself, and sometimes
                good things fall apart so better things can fall together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MoreInfo;
